module.exports = __webpack_public_path__ + "static/media/fondo-ranking.ad563ff4.svg";